// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".or-circle[data-v-2767131a]{background:#fff;font-size:10px;font-weight:600;left:50%;line-height:1;padding:10px 8px;position:absolute;top:50%;transform:translate(-50%,-50%)}.separator[data-v-2767131a]{position:relative}.rounded-border[data-v-2767131a]{border:3px solid #000;border-radius:50%}.menu-landing[data-v-2767131a]{height:70vh}@media screen and (max-width:600px){.menu-landing .no-shadow[data-v-2767131a]{height:55vh;overflow-y:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
